
import { Button } from "@/components/ui/button";
import { TranslationButton } from "@/components/i18n/TranslationButton";

interface ContractFormActionsProps {
  isPending: boolean;
  mode: "create" | "edit";
  onCancel: () => void;
  t: (key: string, fallback?: string) => string;
}

export function ContractFormActions({ 
  isPending, 
  mode, 
  onCancel,
  t
}: ContractFormActionsProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-10 border-t bg-background p-4 flex items-center justify-end space-x-4 shadow-md">
      <TranslationButton
        type="button"
        variant="outline"
        onClick={onCancel}
        i18nKey="cancel"
      >
        {t('cancel', 'Cancel')}
      </TranslationButton>
      <TranslationButton
        type="submit"
        disabled={isPending}
        i18nKey={mode === "create" ? "createContract" : "updateContract"}
      >
        {isPending
          ? t('saving', 'Saving...')
          : mode === "create"
          ? t('createContract', 'Create Contract')
          : t('updateContract', 'Update Contract')}
      </TranslationButton>
    </div>
  );
}
